import { BreakpointObserver } from '@angular/cdk/layout';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { RenderByDeviceService } from 'render/services/base-render-by-device/render-by-device.service';
import { RenderConfigurationService } from 'render/services/render-configuration.service';
import { takeUntil } from 'rxjs';

import { PieceHudsonCarouselSettings } from './models/piece-hudson-carousel.models';


export const ITEMS_PER_ROW_DEFAULT = '5';
export const FORMAT_DEFAULT = 'mosaic';

@Component({
  selector: 'piece-hudson-carousel-render',
  templateUrl: './piece-hudson-carousel-render.component.html',
  styleUrls: ['piece-hudson-carousel-render.component.scss']
})
export class PieceHudsonCarouselRenderComponent
  extends BaseRenderComponent<PieceHudsonCarouselSettings>
  implements OnChanges, AfterViewInit {

  @ViewChild('hudsonScript', { static: false }) public hudsonScript!: ElementRef<HTMLDivElement>;

  public itemsPerRow: string = ITEMS_PER_ROW_DEFAULT;
  public format: string = FORMAT_DEFAULT;

  constructor(
    private readonly renderer: Renderer2,
    private readonly renderConfigService: RenderConfigurationService,
    private readonly renderByDeviceService: RenderByDeviceService,
    private readonly breakpointObserver: BreakpointObserver
  ) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.settings && 'general' in changes.settings.currentValue) {
      if (changes.settings.isFirstChange()) {
        this.breakpointObserver.observe(
          this.renderConfigService.config.breakpoints.map((breakpoint) => breakpoint.bp)
        ).pipe(
          takeUntil(this.clearSubscriptions$)
        ).subscribe(() => {
          this.onMediaChange();
          this.updateScript();
        });
      }
      this.onMediaChange();
      this.updateScript();
    }
  }

  public ngAfterViewInit(): void {
    this.updateScript();
  }

  private setItemsPerRow(itemsPerRow: string): void {
    const parsedItemsPerRow = parseInt(itemsPerRow, 10);

    if (parsedItemsPerRow > 0) {
      this.itemsPerRow = itemsPerRow;
    }
  }

  private setFormat(format: string): void {
    this.format = format;
  }

  private updateScript(): void {
    const idAlbum = this.settings.general?.idAlbum ?? '';
    const script: HTMLScriptElement = this.renderer.createElement('script') as HTMLScriptElement;
    let srcUrl = '';
    let dataName = '';

    if (this.format === 'mosaic') {
      srcUrl = 'https://cdn.dashhudson.com/web/js/board-embed.js';
      dataName = 'dhboard';
    } else {
      srcUrl = 'https://cdn.dashhudson.com/web/js/board-carousel-embed.js';
      dataName = 'dhboard-carousel';
    }

    script.src = srcUrl;
    script.type = 'text/javascript';
    script.setAttribute('data-gallery-id', idAlbum);
    script.setAttribute('data-name', dataName);
    script.setAttribute('data-row-size', this.itemsPerRow);

    if (this.hudsonScript) {
      const container = this.hudsonScript.nativeElement;
      container.innerHTML = '';
      this.renderer.appendChild(container, script);
    }
  }

  private onMediaChange(): void {
    const desktopPerRow = this.piece?.settings?.general?.itemsPerRowDesktop ?? ITEMS_PER_ROW_DEFAULT;
    const desktopFormat = this.piece?.settings?.general?.formatDesktop ?? FORMAT_DEFAULT;

    if (this.renderByDeviceService.isMobile) {
      this.setItemsPerRow(this.piece?.settings?.general?.itemsPerRow ?? desktopPerRow);
      this.setFormat(this.piece?.settings?.general?.format ?? desktopFormat);
    } else {
      this.setItemsPerRow(desktopPerRow);
      this.setFormat(desktopFormat);
    }
  }

}
